






















































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import { State } from 'vuex-class'
import moment from 'moment'

import config from './config'
import { Brand, Channel, Tag, VisibleTag, Campaign, Filter, State as TimelineState, Viewport, Permissions } from './store/timeline'
import { Session } from './store/auth'
import DateField from './components/DateField.vue'
import TimeField from './components/TimeField.vue'
import Timeline from './components/Timeline.vue'
import LoginDialog from './components/LoginDialog.vue'
import UserMenu from './components/UserMenu.vue'
import { State as SnackbarState } from './store/snackbar'

const AUTORELOAD_INTERVAL = 60 * 1000

function mergeDateTime(date: any, time: any) {
    let datePart = date
    if (typeof date === 'object') {
        datePart = moment(date).format('YYYY-MM-DD')
    }
    let timePart = time
    if (typeof time === 'object') {
        timePart = moment(time).format('hh:mm:ss')
    }
    const combined = moment(`${datePart}T${timePart}Z`).toDate()
    return combined
}

@Component({
    components: {
        DateField,
        TimeField,
        Timeline,
        LoginDialog,
        UserMenu,
    },
})
export default class App extends Vue {
    @State(s => s.timeline.brands) brands!: Brand[]
    @State(s => s.timeline.tags) tags!: Tag[]
    @State(s => s.timeline.channels) channels!: Channel[]
    @State(s => s.timeline.campaigns) campaigns!: Campaign[]
    @State(s => s.timeline.viewport) viewport!: Viewport
    @State(s => s.timeline.viewport.tags) viewportTags!: VisibleTag[]
    @State(s => s.timeline.filter) filter!: Filter
    @State(s => s.timeline.loading) loading!: boolean
    @State(s => s.auth.session) session!: Session
    @State(s => s.timeline.userSettings.permissions) permissions!: Permissions
    @State(s => s.snackbar) snackbar!: SnackbarState

    drawerRight = false

    reloadTimeout: number | null = null

    viewportNavUnit: moment.unitOfTime.DurationConstructor = 'w'
    viewportNavUnitChoices = [
        { value: 'd', text: 'Day' },
        { value: 'w', text: 'Week' },
        { value: 'M', text: 'Month' },
        { value: 'y', text: 'Year' },
    ]

    types = [
        {
            text: 'Timeframe',
            value: 'range',
        },
        {
            text: 'Milestone',
            value: 'point/milestone',
        },
        {
            text: 'Deadline',
            value: 'point/deadline',
        },
        {
            text: 'OCD',
            value: 'point/ocd',
        },
        {
            text: 'OBN',
            value: 'point/obn',
        },
    ]

    mounted() {
        // this.setReloadTimeout()
    }

    beforeUnmount() {
        this.clearReloadTimeout()
    }

    setReloadTimeout() {
        this.clearReloadTimeout()
        this.reloadTimeout = window.setTimeout(() => this.reload(), AUTORELOAD_INTERVAL)
    }

    clearReloadTimeout() {
        if (this.reloadTimeout) {
            window.clearTimeout(this.reloadTimeout)
            this.reloadTimeout = null
        }
    }

    reload() {
        this.$store.dispatch('timeline/load')
        // this.setReloadTimeout()
    }

    showChangelog(ev: any) {
        this.$router.push({ name: 'changelog' })
    }

    falconIoImport(ev: any) {
        this.$router.push({ name: 'falconio' })
    }

    get jwt() {
        return this.$store.state.auth.session.jwt
    }

    get exportUrl() {
        return `${config.SERVER_URL}v1.0/viewport/export/`
    }

    get exportPDFUrl() {
        return `${config.SERVER_URL}v1.0/pdf/export/`
    }

    get exportOptions() {
        const timeline = this.$store.state.timeline as TimelineState
        return JSON.stringify({
            start: timeline.viewport.start.toISOString().split('T')[0],
            end: timeline.viewport.end.toISOString().split('T')[0],
            filter: timeline.filter,
        })
    }

    setViewport(start: Date, end: Date) {
        const timeline: any = this.$refs.timeline
        timeline.setViewport(start, end)
    }

    viewportLeft() {
        this.setViewport(
            moment(this.viewport.start).subtract(1, this.viewportNavUnit).toDate(),
            moment(this.viewport.end).subtract(1, this.viewportNavUnit).toDate(),
        )
    }

    viewportRight() {
        this.setViewport(
            moment(this.viewport.start).add(1, this.viewportNavUnit).toDate(),
            moment(this.viewport.end).add(1, this.viewportNavUnit).toDate(),
        )
    }

    get viewportStartDate() {
        return this.viewport.start.toISOString().split('T')[0]
    }

    set viewportStartDate(value: string) {
        this.setViewport(mergeDateTime(value, this.viewport.start), this.viewport.end)
    }

    get viewportStartTime() {
        return this.viewport.start.toISOString().split('T')[1].split('.')[0]
    }

    set viewportStartTime(value) {
        this.setViewport(mergeDateTime(this.viewport.start, value), this.viewport.end)
    }

    get viewportEndDate() {
        return this.viewport.end.toISOString().split('T')[0]
    }

    set viewportEndDate(value) {
        this.setViewport(this.viewport.start, mergeDateTime(value, this.viewport.end))
    }

    get viewportEndTime() {
        return this.viewport.end.toISOString().split('T')[1].split('.')[0]
    }

    set viewportEndTime(value) {
        this.setViewport(this.viewport.start, mergeDateTime(this.viewport.end, value))
    }

    get visibleTags() {
        return this.viewportTags.filter(tag => tag.count > 0)
    }

    get filterTypes() {
        return this.filter.types
    }

    set filterTypes(types: string[]) {
        this.$store.dispatch('timeline/updateFilter', { types })
    }

    get filterTag() {
        return this.filter.tag
    }

    set filterTag(tag: number | undefined) {
        this.$store.dispatch('timeline/updateFilter', { tag })
    }

    get filterCampaign() {
        return this.filter.campaign
    }

    set filterCampaign(campaign: number | undefined) {
        this.$store.dispatch('timeline/updateFilter', { campaign })
    }

    get filterBrands() {
        return this.filter.brands
    }
    set filterBrands(brands) {
        this.$store.dispatch('timeline/updateFilter', { brands })
    }

    get filterChannels() {
        return this.filter.channels
    }
    set filterChannels(channels) {
        this.$store.dispatch('timeline/updateFilter', { channels })
    }

    get brandCampaigns() {
        if (this.filterBrands.length) {
            return this.campaigns.filter(c => this.filterBrands.indexOf(c.brand_id) >= 0)
        } else {
            return this.campaigns
        }
    }

    @Watch('brandCampaigns')
    watchBrandCampaigns() {
        // make sure to deselect campaign from wrong brand
        if (!this.brandCampaigns.find(c => this.filterCampaign === c.id)) {
            this.filterCampaign = null
        }
    }

    get brandChannels() {
        if (this.filterBrands.length) {
            return this.channels.filter(c => this.filterBrands.indexOf(c.brand_id) >= 0)
        } else {
            return this.channels
        }
    }

    @Watch('brandChannels')
    watchBrandChannels() {
        // make sure to deselect channels from wrong brand
        this.filter.channels = this.filter.channels.filter(c => this.brandChannels.find(d => d.id === c))
    }

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue